import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Select,
  MenuItem,
  Box,
  IconButton,
} from "@mui/material";
import { Language, AccountCircle, PersonOutline } from "@mui/icons-material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { useTranslation } from "react-i18next";
import MainMenu from "../components/MainMenu";
import UserMenu from "../components/UserMenu";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";

// 🎨 Colores y estilos centralizados
// const NAVBAR_GRADIENT = "linear-gradient(to right, #6a1b9a, #8e24aa)";
// const NAVBAR_GRADIENT = "#3A1C4F"
const NAVBAR_GRADIENT = "linear-gradient(to right, #3A1C4F, #3E1F55)";

const TEXT_COLOR = "#ffffff";
const SELECT_COLOR = "#ffffff";

const Navbar = () => {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const isEarlyPitcher = !!user?.is_early_pitcher;
  const navigate = useNavigate();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <AppBar
    className="main-navbar"
    position="sticky" // Cambiado a "static" para evitar problemas de scroll, "fixed" si se quiere que quede fijo,
                     //   "absolute" si se quiere que se desplace con el scroll, "sticky" si se quiere que quede pegado al top al hacer scroll
      elevation={0}
      sx={{
        background: NAVBAR_GRADIENT,
        color: TEXT_COLOR,
        borderBottom: "1px solid rgba(255,255,255,0.06)",
      }}
    >
     {/* NAV BAR TRANSPARENTE
     <AppBar
        className="main-navbar"
        position="absolute"
        elevation={0}
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          color: TEXT_COLOR,
          zIndex: 1100,
          top: 0,
          left: 0,
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        }}
      > */}

      {/* <Toolbar sx={{ justifyContent: "space-between" }}> */}
      <Toolbar
        sx={{
          justifyContent: "space-between",
          minHeight: { xs: 48, sm: 56 }, // más compacto en mobile y desktop
          px: { xs: 1, sm: 2 }, // opcional: un poco menos de padding horizontal
        }}
      >
        {/* Logo + Nombre */}
        {/* <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <img src="/assets/logo-icon.png" alt="Logo" style={{ height: 28 }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Pitchest
            </Typography>
          </Box>
        </Link> */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <MainMenu />

          <Typography
            variant="h6"
            onClick={() => navigate("/")}
            sx={{ fontWeight: 600, cursor: "pointer", userSelect: "none" }}
          >
            Pitchest
          </Typography>
        </Box>

        {/* Idioma + Usuario */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Language fontSize="small" />
            <Select
            value={i18n.language}
            onChange={(e) => changeLanguage(e.target.value)}
            size="small"
            variant="standard"
            disableUnderline
  sx={{
    color: SELECT_COLOR,
    fontWeight: 500,
    mt: "4px", // 👈 ajusta la alineación vertical
    ".MuiSelect-icon": {
      color: SELECT_COLOR,
      mt: "-2px" // 👈 también al ícono
    },
  }}
            MenuProps={{
              PaperProps: {
                sx: {
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  "& .MuiMenuItem-root": {
                    fontWeight: 500,
                  },
                  "& .Mui-selected": {
                    color: "#999", // 👈 texto más claro para el seleccionado
                    backgroundColor: "#ffffff",
                  },
                  "& .Mui-selected:hover": {
                    backgroundColor: "#f0f0f0",
                  },
                },
              },
            }}
          >
            <MenuItem value="en">EN</MenuItem>
            <MenuItem value="es">ES</MenuItem>
          </Select>
          </Box>
 
          {/* Badge Early Pitcher (solo si aplica) */}
          {isEarlyPitcher && (
            <IconButton
              onClick={() => navigate("/billing")}
              sx={{
                p: 0,
                ml: -1.5,
                mr: -2,
                "&:hover": { opacity: 0.8 },
              }}
            >
              <WorkspacePremiumIcon
                sx={{ color: "#FACC15", fontSize: 24 }}
              />
            </IconButton>
          )}

          {/* Menu de Usuario */}
          <UserMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
